import { withTranslation } from 'react-i18next'
import OrganizationSprintForm from './OrganizationSprintForm'

export const submitSprintFormHelper = values => {
  const start = values.getIn(['dates', 'startDate']).format('YYYY-MM-DD')
  const end = values.getIn(['dates', 'endDate']).format('YYYY-MM-DD')
  return values
    .set('start', start)
    .set('end', end)
    .set('organizationGoal', parseInt(values.get('organizationGoal')))
    .set('userGoal', parseInt(values.get('userGoal')))
    .delete('dates')
}
export default withTranslation(['admin', 'common'])(OrganizationSprintForm)
